import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

export const ContentCardSekeleton = ({}: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div className="text-grey-200">
            <div className="flex w-full flex-col">
                <div className="relative w-full rounded-xl bg-current pt-[calc(100%/1.6)]" />
                <div className="mt-[4.4%] flex items-start">
                    <div className="relative mr-2 flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-current shadow-[0_0_1px_rgba(0,0,0,0.5)]" />
                    <div className="flex flex-1 flex-col">
                        <div className="mb-1.5 h-6 rounded-sm bg-current" />
                        <div className="h-6 w-[70%] rounded-sm bg-current" />
                    </div>
                </div>
            </div>
        </div>
    );
};
